import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointService } from '@boels/helpers';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'boels-order-entry-accessories-group',
  imports: [CommonModule, TranslocoModule, FaIconComponent],
  templateUrl: './order-entry-accessories-group.component.html',
  styleUrl: './order-entry-accessories-group.component.scss',
  animations: [
    trigger('collapse', [
      state(
        'collapsed',
        style({ height: '0px', overflow: 'hidden', opacity: 0 }),
      ),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class OrderEntryAccessoriesGroupComponent {
  collapsible = input<boolean>(false);
  accessoriesCount = input<number>(0);

  #breakPointService = inject(BreakpointService);
  readonly $isMobile = toSignal(this.#breakPointService.mdAndBelow$, {
    initialValue: false,
  });

  isCollapsed = false;

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  protected readonly faChevronDown = faChevronDown;
  protected readonly faChevronUp = faChevronUp;
}
